import React from 'react';
import { Button } from 'antd-v5';
import { ShareAltOutlined } from '@ant-design/icons';

const RequestedProducts = ({ products, onShare }) => {
  if (!products || products.length === 0) {
    return (
      <div className="qv-section">
        <h3 className="rolex-section-title">Requested Products</h3>
        <span className="qv-section-empty">No requested products</span>
      </div>
    );
  }

  return (
    <div className="qv-section">
      <div
        className="qv-section-header"
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <h3 className="rolex-section-title" style={{ margin: 0 }}>
          Requested Products
        </h3>
        {onShare && (
          <Button icon={<ShareAltOutlined />} onClick={() => onShare(products)}>
            Share with Client
          </Button>
        )}
      </div>
      <div className="rolex-product-list">
        {products.map(product => (
          <div key={product.vendorItemId || product.id} className="rolex-product-card">
            {product.image ? (
              <img
                className="rolex-product-card__image"
                src={product.image}
                alt={product.collectionName || product.mpn}
              />
            ) : (
              <div className="rolex-product-card__image" />
            )}
            <div className="rolex-product-card__info">
              <span className="rolex-product-card__name">{product.collectionName || product.name}</span>
              <span className="rolex-product-card__model">{product.mpn || product.modelNumber}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RequestedProducts;
